import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=450fa0b2&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450fa0b2')) {
      api.createRecord('450fa0b2', component.options)
    } else {
      api.reload('450fa0b2', component.options)
    }
    module.hot.accept("./PageLoader.vue?vue&type=template&id=450fa0b2&", function () {
      api.rerender('450fa0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageLoader.vue"
export default component.exports